export default "__VITE_ASSET__Bx8lMoQ8__"